
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import szloven from "../../assets/szloven.png";

function SzlovenMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Szlovén magyar fordító</title>
                <meta name='description' content="Ingyenes szlovén magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Szlovén magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/szloven-magyar-fordito" />
            </Helmet>
            <h1>Szlovén magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A szlovén nyelvről</h2>
                    <img src={szloven} alt="Szlovén zászló"></img>
                </div>
                <p>A szlovén egy délszláv nyelv, amelyet elsősorban Szlovéniában, egy közép-európai országban beszélnek. Az Európai Unió egyik hivatalos nyelveként is elismert. A szlovén nyelv egyedülálló nyelvtanáról, gazdag irodalmi hagyományáról és a szlovén nép számára kulturális jelentőségéről ismert.</p>

                <p>A szlovén írásrendszer a latin ábécét használja diakritikus jelekkel. 25 betűből áll, beleértve a további karaktereket, például č, š és ž. A szlovén kiejtése általában fonetikus, ami azt jelenti, hogy a szavakat úgy ejtik ki, ahogy írják őket. Minden betűnek konzisztens hangja van, így viszonylag egyszerű megtanulni a szlovén szavak kiejtését.</p>

                <p>A szlovén nyelvtan főnévi ragozásokat, igeragozásokat és nyelvtani eseteket tartalmaz. A főnevek, melléknevek és névmások megváltoztatják alakjukat, hogy jelezzék a nemet, a számot és a kisbetűt. A szlovén nyelvnek hat esete van: névelő, genitivus, datívus, accusative, lokatívusz és instrumentális. Az igék ragozása idő, mód, aspektus és személy szerint történik.</p>

                <p>A szlovén szókincs szláv gyökerű, de más nyelvekből is beépített kölcsönszavakat, különösen német, magyar, olasz és angol nyelvből. A szlovén irodalom gazdag hagyományokkal rendelkezik, olyan neves szerzőkkel, mint France Prešeren, Ivan Cankar és Drago Jančar. A szlovén kultúrát a természethez, a néphagyományokhoz, a zenéhez és a konyhához való erős kötődése jellemzi.</p>

                <p>A szlovén nyelvtudás különféle lehetőségeket kínál. Szlovénia gazdasága stabil és fejlett, különösen az olyan ágazatokban, mint a gyártás, a szolgáltatások és a turizmus. A szlovén nyelv ismerete előnyös lehet ezeken a területeken való karrierhez, vagy a szlovéniai tanulás vagy munka iránt érdeklődők számára.</p>

                <p>A szlovén nyelv a közép-európai kulturális felfedezéshez és utazásokhoz is hasznos. Lehetővé teszi a kommunikációt és a kulturális elmélyülést a szlovén nyelvű közösségekben, és megkönnyíti a kapcsolatokat a szomszédos országokkal, például Ausztriával, Olaszországgal, Horvátországgal és Magyarországgal.</p>

                <p>Ezenkívül a szlovén nyelv tanulása ajtókat nyit Szlovénia kulturális örökségéhez és hagyományaihoz. Lehetővé teszi a szlovén társadalom, szokások és értékek mélyebb megértését. A szlovén néptáncok, a hagyományos ünnepségek és a konyha az ország gazdag kulturális sokszínűségét tükrözik.</p>



            </section>
        </>

    )
}

export default SzlovenMagyar;